module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bb8-block"
  }, [_h('ul', {
    staticClass: "bb8-block-gallery"
  }, [_vm._l((_vm.block.fields.blocks), function(block, index) {
    return _h('li', {
      staticClass: "bb8-block-gallery-item"
    }, [_h('image-block', {
      attrs: {
        "index": index,
        "block": block,
        "config": _vm.config,
        "disallow-allignment": true
      },
      on: {
        "remove-block": _vm.removeImage
      }
    })])
  }), " ", _h('li', {
    staticClass: "bb8-block-gallery-item"
  }, [_h('a', {
    staticClass: "bb8-block-gallery-add-image",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.addImage()
      },
      "keypress": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.addImage()
      }
    }
  }, [_h('svg', {
    staticClass: "icon icon-add-block"
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-add-block"
    }
  })])])])]), " ", _vm._t("default")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60a1381d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/GalleryBlock.vue
// module id = 47
// module chunks = 0